module.exports = __webpack_public_path__ + "static/media/GooglePlay.f4aed8c9.svg";